<!-- <app-image-viewer *ngIf="imageViewer" [images]="[fileUrl]"
[idContainer]="'idOnHTML'"
[loadOnInit]="true">
</app-image-viewer> -->
<div *ngIf="archive" class="card mt-1" style="width: 100%;">
       <div class="card-body">
              <span>
                     <mat-icon class="icon">report_problem</mat-icon>
              </span>
              <span>The document is archived in Glacier storage. Please initiate restore to view the
                     document</span>
              <div>
                     <button style="margin-bottom: 2px; float: right;" mat-raised-button
                            (click)="retrieveGlacierDocument()"> Initiate Restore
                     </button>
              </div>
       </div>
</div>
<div *ngIf="restore" class="card mt-1" style="width: 100%;"> 
       <div class="card-body">
              <span>
                     <mat-icon class="icon">report_problem</mat-icon>
              </span>
              <span>The document has been already initiated for restore. Please check the 'Glacier' tab for it's
                     status</span>
       </div>
</div>
<div *ngIf="!loading && !archive && !restore && isDocumentAvailable">
       <div class="img-zoom" *ngIf="imageViewer" style="height: calc(100vh - 50px);" width="100%" autosize>
              <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
              <label>
                <input type="checkbox">
                <img [src]="fileUrl | safe" (load)="loading = false">
              </label>
       </div>
       <iframe title="Document" *ngIf="!imageViewer" [src]="fileUrl | safe" width="100%" autosize
              style="height: calc(100vh - 50px);">
       </iframe>
</div>
<div *ngIf="!loading && !archive && !restore && !isDocumentAvailable">
       <span>This document has been deleted from the ECM.</span>
</div>



<!--<web-viewer [documentURL]="fileUrl" *ngIf="fileUrl"></web-viewer>-->
<!--
<embed 
       src=safeUrl()
       width="250"
       height="200">
       -->